import React, {
  createContext,
  useState,
  useContext,
  ReactNode,
  useEffect,
} from "react";
import { ProductService } from "../../APIs";
import {
  CartContextProps,
  CartItemContext,
  ProductContext,
  
  WmsOrderDataContext,
} from "../../@types/productInfo";
import { useNotification } from "../Toast/Notification";
import cartServiceInstance, {
 
  CartItemForDB,
} from "../../APIs/cartItems";
import { useAuth } from "../AuthContext/AuthContext";
import { WmsOrderData } from "../../APIs/product";

const CartContext = createContext<CartContextProps | undefined>(undefined);

const generateOrderReference = () =>
  `SSM${Math.random().toString(36).substr(2, 9).toUpperCase()}`;

export const CartProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [cart, setCart] = useState<CartItemContext[]>([]);

  const { notify } = useNotification();
  const { user } = useAuth();

  const [orderReference, setOrderReference] = useState<string | null>(() => {
    const savedRef = localStorage.getItem("orderReference");
    return savedRef || null;
  });

  const [isUpdating, setIsupdating] = useState<boolean>(false);

  const [isDecreasing, setDecreasing] = useState<boolean>(false);
  const [isRemoving, setIsRemoving] = useState<boolean>(false);
  const [availableStock, setAvailableStock] = useState<number | null>(null);
  const [principle, setPrinciple] = useState<string | null>(null);
  const [quantity, setQuantity] = useState<number | null>(null);
  const [checkStockQuantity,  setCheckStockQuantity] = useState<number | null>(null);


  useEffect(() => {
    if (orderReference) {
      localStorage.setItem("orderReference", orderReference);

      getItemFromDB(orderReference);
    }
  }, [orderReference]);

  useEffect(() => {
    if (orderReference) {
      getItemFromDB(orderReference);
    }
  }, [orderReference]);

  const getItemStock = async (sku: string) => {
    try {
      const response = await ProductService.getStockByItemCode(Number(sku));

      if (response.data) {
        const stockData = response.data;
        setAvailableStock(stockData.quantity);
        setPrinciple(stockData.principle);

      } else {
        setAvailableStock(0);
        console.error(
          "an error occurs while fetching available stock :",
          response.error
        );
      }
    } catch (error) {
      console.error("Error fetching stock:", error);
      return { availableStock: 0, principle: "" };
    }
  };

  const checkStockAvaibility = async (sku: string) => {

    try {
      const response = await ProductService.getStockByItemCode(Number(sku));
      if (response.data) {
        if (response.data.quantity) {
          setCheckStockQuantity(response.data.quantity)

          notify("This product is out of stock", "warn");
        
        }
       
      } else {
        console.error(
          "an error occurs while fetching available stock :",
          response.error
        );
      }
    } catch (error) {
      console.error("Error fetching stock:", error);
     
    }
  };


  const [itemStocks, setItemStocks] = useState<Record<string, number>>({});
  const [itemPrincipales, setItemPrincipales] = useState<Record<string, string>>({});
  
  const fetchStockForAllItems = async () => {
    if (!cart || cart.length <= 0) return;
  
    const stockData: Record<string, number> = {};
    const principleData: Record<string, string> = {}; 
  
    const stockPromises = cart.map(async (item) => {
      try {
        const skuNumber = Number(item?.sku);
        if (!isNaN(skuNumber)) {
          const response = await ProductService.getStockByItemCode(skuNumber);
          if (response.data) {
            stockData[item.sku || ""] = response.data.quantity;
            principleData[item.sku || ""] = response.data.principle; // Store principle separately
          }
        }
      } catch (error) {
        console.error(`Error fetching stock for item ${item.sku}:`, error);
      }
    });
  
    await Promise.all(stockPromises);
  
    setItemStocks(stockData);
    setItemPrincipales(principleData);
  
  };
  

  const getItemFromDB = async (order_reference: string) => {
    try {
      const response = await cartServiceInstance.getProductByItemCodes(
        order_reference
      );

      if (
        response?.data &&
        Array.isArray(response.data) &&
        response.data.length > 0
      ) {
        const stockData = response.data;

        setCart(stockData);
      } else {
        console.error(
          "No data found or invalid format for the order reference."
        );
        setCart([]);
        setOrderReference(null);
        localStorage.removeItem("orderReference");
      }
    } catch (error) {
      console.error("Error fetching product by SKU:", error);
    }
  };

  const addToCart = async (product: ProductContext) => {

    setIsupdating(true);
    try {
     if(product){
     
  

      const response2 = await ProductService.getStockByItemCode(Number(product.sku || ""));
      if(response2.data){
        setAvailableStock(response2.data.quantity);

        const now = new Date();
        let currentOrderRef = orderReference;
        if (!currentOrderRef) {
          currentOrderRef = generateOrderReference();
        
        } else {
        
        }
  
        const wmsOrderData: WmsOrderDataContext = {
          OrderNumber: currentOrderRef,
          orderDate: `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
            2,
            "0"
          )}-${String(now.getDate()).padStart(2, "0")}`,
          customerName: "",
          companyName: "Nucleus",
          contactNumber: "",
          addressLine1: "",
          addressLine2: "",
          suburb: "",
          city: "",
          postalCode: "2152",
          itemCode: product.sku || "",
          warehouse: "Sodastream Head Office",
          description: product.name,
          principle: response2.data.principle,
          quantity: 1,
          status: "Reserve",
        }; 
  
        const response = await ProductService.processWmsOrder(wmsOrderData);
        
        if (response?.data && product) {
  
     
          const cartItemForDB: CartItemForDB = {
            user_id: user?.id,
            sku: product.sku,
            item_quantity: 1,
            order_date: `${now.getFullYear()}-${String(
              now.getMonth() + 1
            ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`,
            order_reference: currentOrderRef,
            available_stock: response2.data.quantity,
            principle: principle || "",
            status: "Reserve",
            is_machine: product.is_machine,
            is_black: product.is_black
          };
  
          const {  error } = await cartServiceInstance.addToCart(
            cartItemForDB
          );
          if (error) {
            console.error("Error saving cart item to database:", error);
            return false;
          } else {
  
            setOrderReference(currentOrderRef);
            localStorage.setItem("orderReference", currentOrderRef);
  
            await getItemFromDB(currentOrderRef);
            await getItemStock(product.sku || "");
           
          }
        }
        
      }
   
     
    }
    } catch (error) {
      console.error("Error adding to cart:", error);
      return false;
    } finally {
      setIsupdating(false);
    }
  };

  const removeFromCart = async (product: ProductContext) => {
    setIsRemoving(true)
    try {
      const now = new Date();
      const currentOrderRef = orderReference;
      if (!currentOrderRef) {
        console.error("Trying to remove item without an order reference");
        return false;
      }

      const item = cart.find((item) => item.id === product.id);
      if (!item) return false;



      const wmsOrderData: WmsOrderDataContext = {
        OrderNumber: currentOrderRef,
        orderDate: `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
          2,
          "0"
        )}-${String(now.getDate()).padStart(2, "0")}`,
        customerName: "",
        companyName: "Nucleus",
        contactNumber: "",
        addressLine1: "",
        addressLine2: "",
        suburb: "",
        city: "",
        postalCode: "2152",
        itemCode: product.sku || "",
        warehouse: "Sodastream Head Office",
        description: product.name,
        principle: "",
        quantity: 0,
        status: "Cancel",
      };

      const response = await ProductService.processWmsOrder(wmsOrderData);
      if (response?.data && product) {
        const cartItemForDB: CartItemForDB = {
          user_id: user?.id,
          sku: product.sku,
          quantity: 0,
          item_quantity:  0,
          order_date: `${now.getFullYear()}-${String(
            now.getMonth() + 1
          ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`,
          order_reference: currentOrderRef,
          available_stock: (availableStock || 0) > 0 ? availableStock : 0,
          principle: principle || "",
          status: "Cancel",
    
        };
        const {  error } = await cartServiceInstance.updateCartItem(
          cartItemForDB
        );
        if (error) {
          console.error("Error saving cart item to database:", response.error);
         
        } else {

          setOrderReference(currentOrderRef);
          localStorage.setItem("orderReference", currentOrderRef);

        
          await fetchStockForAllItems();
         
           await getItemStock(product.sku || "");
         
        }
        await getItemFromDB(currentOrderRef);
        if (cart.length <= 0) {
          setCart([]);
          setOrderReference(null);
          localStorage.removeItem("orderReference");
        }
      }
    } catch (error) {
      console.error("Error removing from cart:", error);
      return false;
    } finally {
      setIsRemoving(false)
    }
  };

  const clearCart = async () => {
    try {
      setCart([]);
      setOrderReference(null);
      localStorage.removeItem("orderReference");
    } catch (error) {
      console.error("Error clearing cart:", error);
    }
  };

  const handleIncrease = async (product: ProductContext) => {
    setIsupdating(true);

    if (product) {
      const currentCartItem = cart.find((item) => item.id === product.id);
      const newQuantity = (currentCartItem?.item_quantity ?? 0) + 1;

      setCart((prevCart) =>
        prevCart.map((item) => {
          if (item.id === product.id) {
            return { ...item, item_quantity: newQuantity };
          }
          return item;
        })
      );

      const now = new Date();
      setQuantity(newQuantity);
      try {
        const updatedData: WmsOrderData = {
          OrderNumber: orderReference || "",
          orderDate: "2025-03-08",
          customerName: "",
          companyName: "Nucleus",
          contactNumber: "",
          addressLine1: "",
          addressLine2: "",
          suburb: "",
          city: "",
          postalCode: "",
          itemCode: product.sku || "",
          warehouse: "Sodastream Head Office",
          description: "Sodastream Pepsi® Beverage Mix, 440ml",
          principle: principle || "",
          quantity: newQuantity,
          status: "Update",
        };

        const response = await ProductService.processWmsOrder(updatedData);

        if (response?.data) {

          const cartItemForDB: CartItemForDB = {
            user_id: user?.id,
            sku: product.sku,
            quantity: newQuantity,
            item_quantity: newQuantity,
            order_date: `${now.getFullYear()}-${String(
              now.getMonth() + 1
            ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`,
            order_reference: orderReference ?? "",
            available_stock: (availableStock || 0) > 0 ? availableStock : 0,
            principle: principle || "",
            status: "Update",
            is_machine: currentCartItem?.is_machine,
            is_black:  currentCartItem?.is_black
          };

          const {  error } = await cartServiceInstance.updateCartItem(
            cartItemForDB
          );

          if (error) {
            console.error("Error saving cart item to database:", error);
            return false;
          } else {
          
            await getItemFromDB(orderReference ?? "");
            
          
            await fetchStockForAllItems();
         
            await getItemStock(product.sku || "");
          }
        } else {
       
        }
      } catch (error) {
        console.error("error::", error);
      } finally {
        setIsupdating(false);
      }
    }
  };

  const handleDecrease = async (product: ProductContext) => {
    setDecreasing(true);
  
    if (!product || !product.id) {
      setDecreasing(false);
      return;
    }
  

    const currentItem = cart.find((item) => item.id === product.id);
    
    if (!currentItem) {
      setDecreasing(false);
      return;
    }
    
    const currentQuantity = typeof currentItem.item_quantity === "number" ? currentItem.item_quantity : 0;
    const newQuantity = Math.max(0, currentQuantity - 1);
    
    setCart((prevCart) => 
      prevCart.map((item) => {
        if (item.id === product.id) {
          return { ...item, item_quantity: newQuantity };
        }
        return item;
      })
    );
  
    setQuantity(newQuantity);
    
    // console.log(":", newQuantity);
    
    const now = new Date();

    const item = cart.find((item) => item.id === product.id);
    if (!item) return false;
    
    try {
      const updatedData = {
        OrderNumber: orderReference || "",
        orderDate: "2025-03-08",
        customerName: "",
        companyName: "Nucleus",
        contactNumber: "",
        addressLine1: "",
        addressLine2: "",
        suburb: "",
        city: "",
        postalCode: "",
        itemCode: product.sku || "",
        warehouse: "Sodastream Head Office",
        description: "Sodastream Pepsi® Beverage Mix, 440ml",
        principle: "Pepsi Range",
        quantity: newQuantity,
        status:  newQuantity === 0 ? "Cancel" : "Update",
      };
  
      const response = await ProductService.processWmsOrder(updatedData);
  
      if (response?.data) {
      

        const cartItemForDB = {
          user_id: user?.id,
          sku: product.sku,
          quantity: newQuantity,
          item_quantity: newQuantity,
          order_date: `${now.getFullYear()}-${String(
            now.getMonth() + 1
          ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`,
          order_reference: orderReference ?? "",
          available_stock: (availableStock || 0) > 0 ? availableStock : 0,
          principle: principle || "",
          status:  newQuantity === 0 ? "Cancel" : "Update",
          is_machine:item.is_machine,
          is_black:item.is_black
        };
  
        const {  error } = await cartServiceInstance.updateCartItem(
          cartItemForDB
        );
  
        if (error) {
          console.error("Erreur BD:", error);
        } else {

          await getItemFromDB(orderReference ?? "");

         
            await fetchStockForAllItems();
         
            await getItemStock(product.sku || "");
          
        }
      }
    } catch (error) {
      console.error("Erreur:", error);
    } finally {
      setDecreasing(false);
    }
  };
  
  return (
    <CartContext.Provider
      value={{
        cart,
        orderReference,
        addToCart,
        removeFromCart,
        clearCart,
        getItemStock,
        handleDecrease,
        handleIncrease,
        isUpdating,
        principle,
        availableStock,
        quantity,
        isDecreasing,
        itemStocks,
        setAvailableStock,
        checkStockAvaibility,
        checkStockQuantity,
        itemPrincipales,
        fetchStockForAllItems,
        isRemoving,
        setPrinciple,
        setCart,
        getItemFromDB,
        
        
      }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error("useCart must be used within a CartProvider");
  }
  return context;
};